import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/mapaAT/step1';
import { CTRL_439 } from '../../../validators/439/ctrl439';
import { FormMapaATControlNames } from '../formMapaATControlNames';
import { AvisInitialTypeLight } from '../models/AvisInitialTypeLight';

@Component({
  selector: 'app-avis-initial-type',
  templateUrl: './avis-initial-type.component.html'
})
export class AvisInitialTypeComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() avisInitial : AvisInitialTypeLight;

  public step1 = new Step1();
  public rg1 = CTRL_439.id + '_1';
  public rg2 = 'CTRL_IDWEB';

  constructor() { }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_idWebNames_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_439Names_json() }));
   }

  getUid() {
    return this.uid + '_SepSep_AvisInitialType'
  }

  getStepId() {
	  return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}

  getCtrl_idWebNames_json(): any {
    return { idWeb: "_SepSep_AttributionFromMAPA_SepSep_AvisInitialType_SepAtt_idWeb" };
  }

}
